import { render, staticRenderFns } from "./cardsMobile.vue?vue&type=template&id=5243b18c"
import script from "./cardsMobile.vue?vue&type=script&lang=js"
export * from "./cardsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports